module.exports = __webpack_public_path__ + "static/line-6b114f5ff15b1eaf9eb4d50cc484784a.svg";